const generateKey = () => {
    const max = Number.MAX_VALUE;

    const min = Number.MIN_VALUE;

    return Math.random() * (max - min) + min
}

export { generateKey };
